import type { Phrase } from '@shefira/shared';

import { uiFormat, uiText } from '../ui/text.js';

/**
 * The values of a server line that name game data (a boss, a place, an item,
 * an achievement, an event): translated before they are filled in. Any other
 * value is a player's name, a village (a proper noun, kept as is), a number
 * or a band, and goes in as sent.
 */
const DATA_PARAMS: ReadonlySet<string> = new Set([
  'boss',
  'lair',
  'item',
  'achievement',
  'title',
  'event',
  // A wandering rare's name, who it is, and its region (ADR 0094).
  'rare',
  'epithet',
  'region',
]);

/**
 * A line the server wrote (ADR 0069), in the player's language: its template
 * translated and filled when it carries one, else its French looked up whole.
 * Always through `uiFormat`, so a display that runs `uiText` on the result
 * again leaves it be.
 */
export function serverText(line: Phrase): string {
  if (line.key === undefined) return uiFormat(line.text, {});
  const values: Record<string, string | number> = {};
  for (const [name, value] of Object.entries(line.params ?? {})) {
    values[name] = typeof value === 'string' && DATA_PARAMS.has(name) ? uiText(value) : value;
  }
  return uiFormat(line.key, values);
}
